import type { ClientError } from '@tribeplatform/gql-client/lib'
import type {
  Export,
  MutationCreateExportMemberRequestArgs,
} from '@tribeplatform/gql-client/types'
import type { ExportFields } from '@tribeplatform/gql-client/types/generated'

import {
  useMutation,
  UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useTribeClient } from '../../useTribeClient.js'

export const useCreateExportMemberRequest = (options?: {
  fields?: ExportFields
  useMutationOptions?: UseMutationOptions<
    Export,
    ClientError,
    MutationCreateExportMemberRequestArgs
  >
}) => {
  const { useMutationOptions, fields = 'basic' } = options || {}
  const { client } = useTribeClient()

  return useMutation<
    Export,
    ClientError,
    MutationCreateExportMemberRequestArgs
  >(
    variables =>
      client.mutation({
        name: 'createExportMemberRequest',
        args: {
          fields,
          variables,
        },
      }),
    useMutationOptions,
  )
}
